export const DEFAULT_LOCALE = 'ru';
export const SUPPORTED_LOCALES = ['en', 'ru', 'es', 'pt'];

export function normalizeLocale(lang) {
    if (!lang) return null;
    try {
        const code = String(lang).split('-')[0].toLowerCase();
        return SUPPORTED_LOCALES.includes(code) ? code : null;
    } catch (e) {
        return null;
    }
}

export function detectBrowserLocale() {
    try {
        const nav = typeof navigator !== 'undefined' ? navigator : null;
        const lang =
            (nav && (nav.language || (nav.languages && nav.languages[0]))) ||
            null;
        return normalizeLocale(lang) || null;
    } catch (e) {
        return null;
    }
}

export function detectPreferredLocale() {
    try {
        const stored = localStorage.getItem('locale');
        const normalized = normalizeLocale(stored);
        if (normalized) return normalized;
    } catch (e) {
        // ignore
    }

    return DEFAULT_LOCALE;
}

// Central helper used by APIs to get currently active locale (prefers stored user choice)
export function getActiveLocale() {
    try {
        const stored = localStorage.getItem('locale');
        if (stored) return normalizeLocale(stored) || stored;
    } catch (e) {
        // ignore
    }
    return DEFAULT_LOCALE;
}

// backward-compatible alias expected by API modules
export const _getLocale = getActiveLocale;
